import React, { memo, useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { SelectModal } from '@components/modals/SelectModal';
import { Loader } from '@fourthwall/components';
import * as S from './SelectProductsModal.styled';
import { LoadingList } from './components/LoadingList/LoadingList';
import { ProductsList } from './components/ProductsList/ProductsList';
const SCROLL_TARGET = 'scrollable-list';
const SKELETON_COUNT = 10;
export const SelectProductsModalView = memo(({ title, message, productsStates, innerIds = [], multiple = false, mode, items = [], selectMode, hasNextPage, inputProps, emptyMessage, isLoading, submitButtonLabel, cancelButtonLabel, close, onSubmitClick, onLoadMore, onSelect, onBulkSelect, }) => {
    const renderContent = useMemo(() => {
        if (isLoading) {
            return React.createElement(LoadingList, { count: SKELETON_COUNT });
        }
        if (emptyMessage) {
            return React.createElement(S.IdleContainer, null, emptyMessage);
        }
        return (React.createElement(InfiniteScroll, { dataLength: items.length, loader: React.createElement(S.LoaderWrapper, null,
                React.createElement(Loader, null)), scrollableTarget: SCROLL_TARGET, style: { overflow: 'none' }, hasMore: hasNextPage, next: onLoadMore },
            React.createElement(ProductsList, { items: items, hasNextPage: hasNextPage, multiple: multiple, selectMode: selectMode, innerIds: innerIds, mode: mode, productsStates: productsStates, onSelect: onSelect, onBulkSelect: onBulkSelect })));
    }, [
        isLoading,
        emptyMessage,
        items,
        hasNextPage,
        onLoadMore,
        multiple,
        selectMode,
        innerIds,
        mode,
        productsStates,
        onSelect,
        onBulkSelect,
        message,
    ]);
    return (React.createElement(SelectModal, { title: title, inputProps: inputProps, message: message, content: React.createElement(S.ListContainer, { id: SCROLL_TARGET, "$scrollable": !isLoading && !emptyMessage }, renderContent), submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, close: close, onSubmitClick: onSubmitClick }));
});
SelectProductsModalView.displayName = 'SelectProductsView';
